export default "__VITE_ASSET__BLNdWBnq__"